// extracted by mini-css-extract-plugin
export default {"container":"styles_container__rtr9j","button":"styles_button__hUuaj","text":"styles_text__ILIeR"};